import { Media, Product } from '@gripp/shared-logic';
import { CardButton, MediaListItem, SlideAction, useSlideLayoutSafe } from '@gripp/shared-ui';
import { StyleSheet, View } from 'react-native';
import { useLocation } from 'react-router-dom';
import { ProductFileItemMenu } from './productFileItemMenu';

type Props = {
  product?: Product;
  media: Media;
  invalidateQuery: () => void;
  onPress?: (media: Media) => void;
  useCropCircle?: boolean;
};

export const ProductFileItem = ({ product, media, invalidateQuery, onPress, useCropCircle }: Props) => {
  const slideLayout = useSlideLayoutSafe();
  const location = useLocation();

  if (!useCropCircle) {
    return (
      <MediaListItem
        media={media}
        invalidateQuery={invalidateQuery}
        menu={
          product && (
            <ProductFileItemMenu
              product={product}
              media={media}
              invalidateQuery={invalidateQuery}
            />
          )
        }
      />
    );
  };

  return (
    <View style={styles.container}>
      <View style={styles.cardButton}>
        <CardButton
          text={media.name}
          color="white"
          leftIcon="Document B"
          rightIcon="Chevron Right"
          showAvatars={false}
          bordered={false}
          onPress={media.id ? async () => {
              const isFileUrl = /\/products\/[^/]+\/files\/[^/]+/.test(location.pathname);
              if (!isFileUrl) {
                await slideLayout?.onSlideChange(SlideAction.NEXT);
              }
              onPress?.(media);
            } : undefined}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  cardButton: {
    flex: 1,
  },
});
